import styled from "styled-components";

export const ListGroupStages = styled.div`
  height: 100%;   
  box-sizing: border-box;
  .status-list {
    padding: 20px 20px 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
    .status-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 10px 7px 10px; 
      min-width: 250px; 
      border-radius: 5px;
      &__button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 20px;
        padding: 10px;
        width: 100%;
        background-color: #EDEBF7;
        font-family: Nunito Sans;
        font-size: 17px;
        color: #1F1F52; 
        text-align: center;
        outline: none;
        border: none;
        cursor: pointer;
        &--selected {
          color: #1168FF;
          font-family: Nunito Sans bold;
        }
        &--current {
          background-color: #EDEBF7;
          color: #6C6BF5;
          font-family: Nunito Sans bold;
        }
        &--disabled {
          background-color: #EDEBF7;
          cursor: default;
          color: #707582;
          opacity: 0.45
        }
      }
      &__left {
        display: flex;
        align-items: center;
      }
      &__text {

      }
      &__radio-button {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border: 1.2px solid #2A28D6;
        background-color: #FFFFFF;
        padding: 3px;
        box-sizing: border-box;
        display: flex;
        margin-right: 5px;
        &-content {
          width: 14px;
          border-radius: 50%;
          background-color: #1168FF;
        }
      }
      &__caption {
        font-size: 11px;
        color: #707582;
        font-family: Nunito Sans;
        font-size: 13px;
        height: 16px;
        &--selected {
          color: #6C6BF5;
        }
      }
    }
  }
`